
import PreEntryApi from '../../assets/js/preentry'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
XButton,
Flexbox,
FlexboxItem,
Divider,
XHeader,
Loading
},
data () {
return {
id: '',
offer_title: '',
download_title: '',
get_info_title: '',
accept_title: '',
refuse_title: '',
hiring_type: 1,
code: '',
offer_application_id: '',
pdf_url: '',
has_offer: '',
pre_code_new: '',
pre_pass: '',
is_pre: false, // 预览模式
is_check_pass: false, // 验证信息通过
status: '',
contract_type: '劳动合同',
data: {
format_date: ['', '', ''],
format_nowdate: ['', '', '']
},
showLoading: true,
html_info: ''
}
},
created () {
this.id = this.$route.query.id
this.pre_pass = this.$route.query.pre_pass
this.pre_code_new = this.$route.query.pre_code_new

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')

if (!this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

if (!this.code && !this.pre_pass) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
if (this.pre_pass) {

PreEntryApi.checkPreLogin(
{ id: this.id, code: this.pre_code_new, pre_pass: this.pre_pass },

(data, meta) => {
this.is_pre = true
this.is_check_pass = true
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.pre_code_new },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)
PreEntryApi.getStaffDetail(
{ id: this.id, code: this.pre_code_new, from: 'ehr' },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
this.hiring_type = data.hiring_type
this.offer_application_id = data.offer_application_id
this.contract_type = data.contract_type
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}
if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}
this.showLoading = false
}
},

err => {
if (err === -2) {
this.$message.error(this.$tsg('详情信息未获取，请刷新当前页面'))
} else {
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
).then(data => {
PreEntryApi.getOfferInfo(
{key: this.offer_application_id, id: this.id, code: this.code},

(data, meta) => {
if (data) {
this.html_info = data.html_info
this.pdf_url = data.pdf_url
this.offer_title = data.language === 'en' ? 'Li Auto Offer Letter' : '理想汽车 Offer Letter'
this.download_title = data.language === 'en' ? 'Download OfferPDF' : '下载OfferPDF'
this.accept_title = data.language === 'en' ? 'Accept Offer' : '接受Offer'
this.refuse_title = data.language === 'en' ? 'Refuse Offer' : '拒绝Offer'
this.get_info_title = data.language === 'en' ? 'Get Into' : '进入'
}
}
)
})
})
} else {

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {
this.is_check_pass = true
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)
PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
this.hiring_type = data.hiring_type
this.contract_type = data.contract_type
this.offer_application_id = data.offer_application_id
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}
if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}
if (!this.data.bce_offer_url) {
this.createOfferPDF()
} else {
this.showLoading = false
}
this.showLoading = false
}
},

err => {
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
).then(data => {
PreEntryApi.getOfferInfo(
{key: this.offer_application_id, id: this.id, code: this.code},

(data, meta) => {
if (data) {
this.html_info = data.html_info
this.pdf_url = data.pdf_url
this.offer_title = data.language === 'en' ? 'Li Auto Offer Letter' : '理想汽车 Offer Letter'
this.download_title = data.language === 'en' ? 'Download OfferPDF' : '下载OfferPDF'
this.accept_title = data.language === 'en' ? 'Accept Offer' : '接受Offer'
this.refuse_title = data.language === 'en' ? 'Refuse Offer' : '拒绝Offer'
this.get_info_title = data.language === 'en' ? 'Get Into' : '进入'
}
}
)
})
})
}
},
methods: {
historyBack () {
if (this.$route.name === 'onboard.preview' && this.$route.query.back === 1) {
this.$router.push({ name: 'onboard.code', query: { id: this.$route.query.id } })
return false
} else if (this.$route.name === 'onboard.code') {
window.close()
return false
} else {
history.go(-1)
}
},
createOfferPDF () {
PreEntryApi.createOfferPDF(
{ id: this.id, code: this.code },

(data, meta) => {
this.showLoading = false
},

err => {
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
},

downloadOffer () {
window.open(this.pdf_url)
},

refuseOffer () {
this.$router.push({ name: 'onboard.school_refuse', query: { id: this.id } })
},

acceptOffer () {
const currentDomain = window.location.hostname
if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
return true
} else if (currentDomain.includes('.test')) {
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
return true
}
PreEntryApi.confirmOffer(
{ id: this.id, code: this.code },
(data, meta) => {
if (data !== '') {
this.$message.error('接受offer失败。')
return false
}

if (this.hiring_type === 1) {
/**
* *员工组=蓝领，且
*     （部门=研发与供应群组-制造、零部件集群
*      部门=研发与供应群组-质量安全、工作城市=常州，
*      部门=研发与供应群组-供应链、工作城市=常州
*      不需要上传体检报告
*      部门=研发与供应群组-制造、零部件集群
*/
if (this.data.job_type === 2 && (this.data.department2_id === 129 || this.data.department2_id === 12859 || (this.data.department2_id === 9463 && this.data.work_city_name === '常州市') || (this.data.department2_id === 77 && this.data.work_city_name === '常州市'))) {
this.$router.push({
name: 'onboard.privacy_tips',
query: { id: this.id }
})
return true
}
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
} else {
if (this.contract_type === '实习协议') {
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
return
}

this.$router.push({ name: 'onboard.school_graduate', query: { id: this.id } })
}
},
err => {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/new_common_offer.vue